// extracted by mini-css-extract-plugin
export default {"customerTableInfo__header":"styles_customerTableInfo__header__qvpP2"};